import React from 'react'
import { FaSearch } from 'react-icons/fa'
import './css/searchbar.css'

function SearchBar({ searchTerm, setSearchTerm, onSearch, placeholder = "Search for events..." }) {
  return (
    <div className="search-bar">
      <button
        className="search-button"
        onClick={() => onSearch(searchTerm)}
      >
        <FaSearch />
      </button>
      <input
        type="text"
        placeholder={placeholder}
        className="search-input"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
    </div>
  );
}

export default SearchBar
